import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import type { GetAggregatedReportFolderListParams } from './get-aggregated-report-folder-list';
import { getAggregatedReportFolderList } from './get-aggregated-report-folder-list';
import type { GetAggregatedReportListParams } from './get-aggregated-report-list';
import { getAggregatedReportList } from './get-aggregated-report-list';
import type { GetReportParams } from './get-report';
import { getReport } from './get-report';

export const reportQueryKeys = {
  all: ['report'] as const,
  aggregatedLists: () => [...reportQueryKeys.all, 'aggregated-list'] as const,
  aggregatedList: (params: GetAggregatedReportListParams) =>
    [...reportQueryKeys.aggregatedLists(), params] as const,
  aggregatedFolderLists: () =>
    [...reportQueryKeys.all, 'aggregated-folder-list'] as const,
  aggregatedFolderList: (params: GetAggregatedReportFolderListParams) =>
    [...reportQueryKeys.aggregatedFolderLists(), params] as const,
  details: () => [...reportQueryKeys.all, 'detail'] as const,
  detail: (params: GetReportParams) =>
    [...reportQueryKeys.details(), params] as const,
};

export function aggregatedReportListQueryOptions(
  params: GetAggregatedReportListParams,
) {
  return queryOptions({
    queryKey: reportQueryKeys.aggregatedList(params),
    queryFn: () => getAggregatedReportList(params),
    enabled: Boolean(params.workspace_id),
    placeholderData: keepPreviousData,
  });
}

export function aggregatedReportFolderListQueryOptions(
  params: GetAggregatedReportFolderListParams,
) {
  return queryOptions({
    queryKey: reportQueryKeys.aggregatedFolderList(params),
    queryFn: () => getAggregatedReportFolderList(params),
    enabled: Boolean(params.workspace_id),
  });
}

export function reportDetailQueryOptions(
  params: GetReportParams,
  options?: { enabled?: boolean },
) {
  return queryOptions({
    queryKey: reportQueryKeys.detail(params),
    queryFn: () => getReport(params),
    enabled: Boolean(params.report_id),
    ...options,
  });
}
